export interface Option {
  text: string;
  value: string;
  pattern?: 'A' | 'B' | 'C' | 'D' | 'E';
}

export interface PartnerQuestion {
  id: number;
  text: string;
  options: Option[];
}

export const partnerQuestions: PartnerQuestion[] = [
  {
    id: 1,
    text: '¿Cómo describirías la mayoría de vuestras conversaciones difíciles?',
    options: [
      {
        text: 'Uno quiere hablar, el otro se cierra o se va',
        value: 'A',
        pattern: 'C'
      },
      {
        text: 'Damos vueltas a lo mismo sin llegar a nada',
        value: 'B',
        pattern: 'A'
      },
      {
        text: 'Siempre aparece un tercero (hijos, familia, trabajo) que interrumpe',
        value: 'C',
        pattern: 'B'
      },
      {
        text: 'Ya ni intentamos hablar, cada uno en lo suyo',
        value: 'D',
        pattern: 'D'
      },
      {
        text: 'Cuesta, pero acabamos llegando a acuerdos',
        value: 'E',
        pattern: 'E'
      }
    ]
  },
  {
    id: 2,
    text: '¿Quién toma las decisiones importantes en casa?',
    options: [
      {
        text: 'Mi pareja decide casi todo, yo me adapto',
        value: 'A',
        pattern: 'A'
      },
      {
        text: 'Yo decido porque mi pareja pasa de todo',
        value: 'B',
        pattern: 'A'
      },
      {
        text: 'Los hijos/familia/otros tienen más peso que nosotros dos',
        value: 'C',
        pattern: 'B'
      },
      {
        text: 'Decidimos juntos, aunque a veces cueste',
        value: 'D',
        pattern: 'E'
      }
    ]
  },
  {
    id: 3,
    text: '¿Qué pasa cuando uno de los dos necesita algo del otro?',
    options: [
      { text: 'Lo pido, pero casi nunca llega', value: 'A', pattern: 'A' },
      {
        text: 'No lo pido porque ya sé que no va a cambiar nada',
        value: 'B',
        pattern: 'D'
      },
      {
        text: 'Uno siempre da, el otro siempre recibe',
        value: 'C',
        pattern: 'A'
      },
      {
        text: 'Lo pido y normalmente funciona, aunque no siempre',
        value: 'D',
        pattern: 'E'
      }
    ]
  },
  {
    id: 4,
    text: '¿Hay alguien (hijos, suegros, trabajo, ex) que tenga más espacio en tu relación que tu propia pareja?',
    options: [
      { text: 'Sí, los hijos siempre van primero', value: 'A', pattern: 'B' },
      {
        text: 'Sí, su familia (o la mía) tiene mucho peso',
        value: 'B',
        pattern: 'B'
      },
      {
        text: 'Sí, el trabajo/dinero ocupa todo el espacio',
        value: 'C',
        pattern: 'B'
      },
      { text: 'No, mi pareja y yo somos prioridad', value: 'D', pattern: 'E' }
    ]
  },
  {
    id: 5,
    text: 'Cuando hay conflicto, ¿qué suele pasar?',
    options: [
      { text: 'Uno explota, el otro se encierra', value: 'A', pattern: 'C' },
      {
        text: 'Discutimos, pero al final siempre volvemos al mismo punto',
        value: 'B',
        pattern: 'A'
      },
      {
        text: 'Evitamos el conflicto a toda costa, mejor no tocar temas',
        value: 'C',
        pattern: 'D'
      },
      {
        text: 'Ya ni peleamos, cada uno por su lado',
        value: 'D',
        pattern: 'D'
      },
      {
        text: 'Discutimos, pero acabamos resolviendo',
        value: 'E',
        pattern: 'E'
      }
    ]
  },
  {
    id: 6,
    text: '¿Qué palabra describe mejor cómo te sientes ahora?',
    options: [
      { text: 'Agotado/a', value: 'A' },
      { text: 'Solo/a', value: 'B' },
      { text: 'Atrapado/a', value: 'C' },
      { text: 'Confundido/a', value: 'D' },
      { text: 'Tranquilo/a, pero quiero mejorar', value: 'E' }
    ]
  },
  {
    id: 7,
    text: '¿Cuánto tiempo llevan en este ciclo?',
    options: [
      { text: '6-12 meses', value: 'A' },
      { text: '1-3 años', value: 'B' },
      { text: '3-5 años', value: 'C' },
      { text: 'Más de 5 años', value: 'D' },
      {
        text: 'No hay problema grave, solo quiero fortalecer lo que funciona',
        value: 'E'
      }
    ]
  },
  {
    id: 8,
    text: 'Si nada cambia en 6 meses, cómo te sentirías?',
    options: [
      { text: 'Probablemente buscaría separarme', value: 'A' },
      { text: 'Seguiría buscando formas de mejorarla', value: 'B' },
      { text: 'Aguantaría por los hijos/estabilidad', value: 'C' },
      { text: 'No lo sé, estoy muy confundido/a', value: 'D' },
      { text: 'Bien, solo quiero que sea aún mejor', value: 'E' }
    ]
  }
];

export interface ResultAction {
  title: string;
  text: string;
}

export interface PartnerResult {
  title: string;
  subtitle: string;
  whatHappeningTitle: string;
  whatHappeningInfo: string;
  whyRepairsTitle: string;
  whyRepairsInfo: string;
  actionsTitle: string;
  actions: ResultAction[];
  nextStep: string;
  calendlyLink: string;
}

export const partnerResults: Record<string, PartnerResult> = {
  A: {
    title: 'EQUILIBRIO ROTO',
    subtitle: 'Tu patrón: Uno da todo, el otro recibe (o viceversa)',
    whatHappeningTitle: '¿Qué está pasando?',
    whatHappeningInfo:
      'En tu relación, uno de los dos está dando mucho más de lo que recibe: tiempo, afecto, esfuerzo, dinero, cuidado. El otro recibe, pero no compensa.\n\nCon el tiempo, el que da se agota y se llena de resentimiento. El que recibe se siente en deuda, o incluso empequeñecido. Y aunque nadie lo diga en voz alta, ambos sienten que algo está roto.',
    whyRepairsTitle: '¿Por qué se repite?',
    whyRepairsInfo:
      'Este patrón NO se repite porque uno sea malo o egoísta. Se repite porque:\n\n- No aprendiste a pedir lo que necesitas (con claridad, sin culpa)\n- No aprendiste a decir que no (sin sentirte culpable)\n- Crees que amar es darlo todo, aunque te vacíes\n- O crees que si pides algo, significa que tu pareja no te quiere de verdad\n\nNadie os enseñó que una relación sana es un intercambio: ambos dan, ambos reciben.',
    actionsTitle: '3 ACCIONES QUE PUEDES HACER HOY',
    actions: [
      {
        title: 'NOMBRA EL DESEQUILIBRIO (sin atacar)',
        text: '"Últimamente siento que doy mucho y recibo poco. Necesito que hablemos."'
      },
      {
        title: 'PIDE ALGO CONCRETO (nada abstracto)',
        text: 'En vez de "necesito que me valores más", di: "Cuando llegues del trabajo, pregúntame cómo estoy ANTES de revisar el móvil. Esos 2 minutos me hacen sentir que me ves."'
      },
      {
        title: 'PRACTICA DECIR NO (sin culpa)',
        text: 'Si siempre das, empieza a decir no a algo pequeño. Si siempre recibes, pregunta "¿qué necesitas tú?"'
      }
    ],
    nextStep:
      'Este patrón tiene solución, pero necesitas ayuda externa. Hemos visto este patrón decenas de veces. Y sabemos exactamente cómo romperlo.',
    calendlyLink: 'https://themindessence.com/entrevista-pareja'
  },
  B: {
    title: 'TERCEROS PRIORITARIOS',
    subtitle:
      'Tu patrón: Los hijos / familia / trabajo tienen más voz que tu pareja',
    whatHappeningTitle: '¿Qué está pasando?',
    whatHappeningInfo:
      'En tu relación, hay alguien (o algo) que tiene más espacio que tu propia pareja:\n\n- Los hijos siempre van primero\n- Su familia (o la tuya) tiene demasiado peso en las decisiones\n- El trabajo ocupa todo el tiempo y energía\n- Hay un ex, un duelo, o alguien no cerrado que sigue presente\n\nEl resultado es el mismo: tu pareja quedó en segundo plano. Y aunque esté físicamente ahí, emocionalmente ya no está.',
    whyRepairsTitle: '¿Por qué se repite?',
    whyRepairsInfo:
      'Este patrón NO es porque ames más a tus hijos o a tu trabajo. Se repite porque:\n\n- Crees que ser buen padre/madre es poner a los hijos siempre primero (error)\n- No saben cómo poner límites a tu familia de origen sin sentirte culpable\n- Usas el trabajo/hijos como escudo para no enfrentar los problemas de pareja\n- Nadie te enseñó que la pareja debe ser prioridad ANTES que los hijos (para que los hijos estén bien)\n\nUna pareja débil = hijos inseguros. Una pareja fuerte = hijos seguros.',
    actionsTitle: '3 ACCIONES QUE PUEDES HACER HOY',
    actions: [
      {
        title: 'CREA UN ESPACIO SEMANAL SOLO PARA LA PAREJA (no negociable)',
        text: '1 hora a la semana, sin hijos, sin familia, sin trabajo. Hablen de ustedes dos.'
      },
      {
        title: 'TOMA UNA DECISIÓN JUNTOS (sin consultar a terceros)',
        text: 'Algo pequeño. Pero que sea decisión de USTEDES DOS, no de los suegros o los hijos.'
      },
      {
        title: 'DI EN VOZ ALTA: "TÚ ERES MI PRIORIDAD"',
        text: 'Y demuéstralo con UNA acción concreta esta semana.'
      }
    ],
    nextStep:
      'Este patrón destruye parejas silenciosamente. Pero tiene solución si actúas ahora. Sabemos exactamente cómo reordenar esto.',
    calendlyLink: 'https://themindessence.com/entrevista-pareja'
  },
  C: {
    title: 'DISTANCIA-PERSECUCIÓN',
    subtitle: 'Tu patrón: Uno persigue, el otro se cierra',
    whatHappeningTitle: '¿Qué está pasando?',
    whatHappeningInfo:
      'En tu relación hay un patrón claro:\n\n- Uno quiere hablar, acercarse, resolver\n- El otro se cierra, se va, necesita espacio\n\nCuanto más persigue uno, más se cierra el otro. Cuanto más se cierra uno, más persigue el otro. Es un círculo vicioso donde AMBOS están atrapados. Y nadie sabe cómo salir sin hacerlo peor.',
    whyRepairsTitle: '¿Por qué se repite?',
    whyRepairsInfo:
      'Este patrón NO es porque uno sea dependiente y el otro frío. Se repite porque:\n\n- El que persigue interpreta la distancia como rechazo (y se activa más)\n- El que se cierra interpreta la persecución como presión (y se cierra más)\n- Ninguno de los dos sabe cómo romper el ciclo\n\nEn el fondo, AMBOS quieren lo mismo: conexión. Pero vuestras estrategias son opuestas.',
    actionsTitle: '3 ACCIONES QUE PUEDES HACER HOY',
    actions: [
      {
        title: 'SI ERES EL QUE PERSIGUE — PARA',
        text: 'En vez de insistir, di: "Cuando estés listo/a para hablar, avísame. Estaré aquí."'
      },
      {
        title: 'SI ERES EL QUE SE CIERRA — DA UN PASO HACIA EL OTRO',
        text: 'No hace falta una conversación profunda. Solo di: "Sé que necesitas hablar. Dame X horas y te escucho."'
      },
      {
        title: 'ACUERDEN UNA PAUSA-RETORNO',
        text: 'Si empieza el ciclo, usen una señal: "Pausa. Retomamos en 2 horas." Sin juzgar, sin castigar.'
      }
    ],
    nextStep:
      'Este patrón es agotador. Pero tiene solución si lo trabajas con alguien que sepa guiarte. Hemos visto este ciclo decenas de veces. Sabemos exactamente cómo romperlo (sin terapia de años).',
    calendlyLink: 'https://themindessence.com/entrevista-pareja'
  },
  D: {
    title: 'DISTANCIA EMOCIONAL',
    subtitle: 'Tu patrón: Convivís, pero cada uno en su mundo',
    whatHappeningTitle: '¿Qué está pasando?',
    whatHappeningInfo:
      'En tu relación ya no hay conexión. Viven juntos, pero cada uno en su mundo:\n\n- Ya ni pelean (porque para qué)\n- No hay intimidad\n- Cada uno con su rutina\n- Están juntos por costumbre, por los hijos, o porque separarse da miedo\n\nEl problema no es que peleen. El problema es que ya ni lo intentan.',
    whyRepairsTitle: '¿Por qué se repite?',
    whyRepairsInfo:
      'Este patrón NO aparece de un día para otro. Es el resultado de años de:\n\n- Conflictos no resueltos\n- Necesidades no expresadas\n- Distancia emocional creciente\n- Pequeñas desconexiones que se acumularon\n\nY ahora están tan lejos que no saben ni por dónde empezar.',
    actionsTitle: '3 ACCIONES QUE PUEDES HACER HOY',
    actions: [
      {
        title: 'HAZ UNA PREGUNTA REAL (no automática)',
        text: 'En vez de "¿cómo estás?" (que se responde con "bien"), pregunta: "¿Qué fue lo mejor y lo peor de tu día?"'
      },
      {
        title: 'TOCA A TU PAREJA (sin expectativas sexuales)',
        text: 'Un abrazo. Una mano en el hombro. Contacto físico sin demanda. Solo presencia.'
      },
      {
        title: 'DI EN VOZ ALTA: "NO QUIERO QUE SEAMOS EXTRAÑOS"',
        text: 'Y propon 15 minutos de conversación real esta semana. Solo 15 minutos.'
      }
    ],
    nextStep:
      'Si estás aquí es porque todavía hay algo. Pero este patrón necesita intervención YA, o se acaba. Hemos ayudado a decenas de parejas en este punto. Algunas se reconstruyen. Otras se separan con dignidad. Pero todas necesitan claridad.',
    calendlyLink: 'https://themindessence.com/entrevista-pareja'
  },
  E: {
    title: 'PAREJA FUNCIONAL',
    subtitle: 'Vuestra relación está en el rango de funcionalidad saludable',
    whatHappeningTitle: '¿Qué significa esto?',
    whatHappeningInfo:
      'Tu relación NO está en crisis. Tenéis roces normales, conflictos ocasionales, pero los gestionáis. Pedís lo que necesitáis. Os escucháis. Llegáis a acuerdos. ¿Por qué hiciste este test entonces? Porque sabes que una relación no se mantiene sola. Y estás siendo proactivo/a antes de que aparezcan problemas graves. Eso es inteligente.',
    whyRepairsTitle: '¿Qué necesita tu relación ahora?',
    whyRepairsInfo:
      'No necesitas terapia intensiva. No necesitas romper patrones graves. Necesitas mantenimiento preventivo: rituales que sostengan la conexión, herramientas para conflictos futuros y claridad en límites con terceros (familia, trabajo, hijos).',
    actionsTitle: '3 ACCIONES PARA MANTENER LO QUE FUNCIONA',
    actions: [
      {
        title: 'CREA UN RITUAL SEMANAL (no negociable)',
        text: '1 hora a la semana, sin hijos, sin móviles. Habláis de USTEDES DOS (no de logística familiar). Preguntas útiles: ¿Qué necesitaste de mí esta semana que no te di? ¿Qué te hizo sentir cerca de mí esta semana?'
      },
      {
        title: 'PROTOCOLO DE PAUSA-RETORNO (prevención)',
        text: 'Cuando empiece a subir la tensión, usad una señal: "Pausa. Retomamos en 2 horas." Sin juzgar, sin castigar. Solo pausa. Esto evita 90% de escaladas innecesarias.'
      },
      {
        title: 'AGRADECIMIENTO CONCRETO (3 veces/semana)',
        text: 'No "gracias por todo". Sí "gracias por preguntarme cómo estaba esta mañana, me hizo sentir visto/a". La gratitud específica refuerza lo que funciona.'
      }
    ],
    nextStep:
      'Si quieres profundizar en límites con familia de origen, prevenir desgaste o mantener intimidad, tenemos 20 minutos de evaluación gratuita donde vemos tu caso específico. Pero insistimos: Esto sería hacerla más saludable, no repararla cuando ya esté rota. El 90% de parejas espera a estar en crisis para actuar. Tú estás siendo inteligente al prevenir. Eso dice mucho de ti.',
    calendlyLink: 'https://themindessence.com/entrevista-pareja'
  }
};
